export default "__VITE_ASSET__Dl8WZOoG__"